<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260">
    <v-img
      height="100%">
      <div tag="v-row">

        <v-list-item>
          <v-list-item-avatar color="white">
            <v-img :src="logo" height="34" contain/>
          </v-list-item-avatar>
          <v-list-item-title class="title">
            {{ nomeUsuario }}
          </v-list-item-title>
        </v-list-item>

        <v-divider light/>

        <v-list-item
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          class="v-list-item">
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="link.text" />
        </v-list-item>

      </div>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations } from 'vuex'
import firebase from 'firebase'

export default {
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    logo: 'favicon.ico',
    links: [
      {
        to: '/',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard'
      },
      {
        to: '/apresentacoes',
        icon: 'mdi-microphone-variant',
        text: 'Apresentações'
      },
      {
        to: '/repertorio',
        icon: 'mdi-book-music',
        text: 'Repertório'
      },
      {
        to: '/votacao',
        icon: 'mdi-vote',
        text: 'Votação'
      },
      {
        to: '/inventario',
        icon: 'mdi-bag-carry-on',
        text: 'Inventário'
      }
    ]
  }),
  computed: {
    inputValue: {
      get: function () {
        return this.$store.state.drawer
      },
      set: function (val) {
        this.$store.commit('setDrawer', val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    },
    nomeUsuario: function () {
      if (firebase.auth().currentUser) return firebase.auth().currentUser.displayName.split(' ')[0]
      else return 'Visitante'
    }
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer'])
  }
}
</script>

<style lang="scss">
  #app-drawer {

    .v-list__item {
      border-radius: 4px;
    }
  }

  .v-list-item {
    margin: 0 15px;
  }

  .v-list-item:not(:nth-child(1)) {
    margin: 10px 15px 0;
  }
</style>
